import { $, $$, setElementFocus } from 'dlr-utils/helpers';

/**
 * IMPORTANT: THIS WILL ALWAYS BE AN ARRAY
 * Always make it possible for multiple instances
 * of your module to work on the pages.
 */
const SELECTOR = '.dlr-newsletter';
const INSTANCES = $$(SELECTOR);

/* If you want to target just one, just uncomment the line below */
const ELEMENT = INSTANCES[0];


/**
 * 1. Mounting
 *
 * Put module-specific variables and functions here.
 * Actions in this scope will fire as soon as the module
 * is mounted (not yet attached to the page)
 *  e.g. setting of initial states (see below), data fetching, etc
 *
 * The default export functions are the only
 * ones used by the dynamic module importer (main.js).
 * upon page load. main.js will only fire these if
 * at least one element with the class ".dlr-newsletter" exists
 */
const HAS_ERROR = '--has-error';
const IS_EXPANDED = '--is-expanded';
const FORM_SUCEESS = '--form-success';

const emailSubmitBtn = $(`${SELECTOR}__email-submit`, ELEMENT);
const closeBtn = $(`${SELECTOR}-modal__close-btn`, ELEMENT);

let htmlForm = null;

export default {
  /**
   * 2. REGISTRATION
   *
   * Use `init` for actions that should fire as soon as
   * the module file has been made available to the page
   *  - e.g. data transformations, MessageBus Subscriptions
   */
  init(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    console.log('newsletter init');

    // svg icons
    const svg = {
      submit: `<svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.5H14.5" stroke="var(--stroke-color, var(--warm-red))" stroke-width="1.5"/><path d="M9 1L15 7.5L9 14" stroke="var(--stroke-color, var(--warm-red))" stroke-width="1.5"/></svg>`,
      check: `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7.04396L5.65909 12L16 1" stroke="var(--stroke-color, var(--warm-red))" stroke-width="1.5"/></svg>`
    }

    MessageBus.subscribe('EMAIL_SUBMIT', ({ module, event }) => {
      event.preventDefault();

      const emailFieldContainer = $(`${SELECTOR}__email-field`, module);
      const emailField = $('input', emailFieldContainer);
      const errorMsgElement = $('.error-msg', emailFieldContainer);
      const { value } = emailField;
      let hasError = false;
      let errorMsg;

      // clean form
      module.classList.remove(HAS_ERROR)
      if (errorMsgElement) errorMsgElement.remove();

      // validation
      if (value.length <= 0) {
        hasError = true;
        errorMsg = 'Please enter your email address';
      }

      if (!/\b[A-z0-9\.!#$%&'*+-/=?^_`{|}~]+@[A-z]+\.[A-z]{2,}\b/g.test(value) && value.length > 0) {
        hasError = true;
        errorMsg = 'Please enter a valid email address';
      }

      
      if (hasError) {
        emailField.insertAdjacentHTML('afterend', `<span class="error-msg">${errorMsg}</span>`);
        module.classList.add(HAS_ERROR);
        emailField.focus();
      } 
      else {
        MessageBus.publish('MODAL_HANDLER', { module: ELEMENT, isExpanded: true, emailValue: value });
      }

    });


    MessageBus.subscribe('GFORM_INIT', ({ module }) => {
      const gformContainer = $(`${SELECTOR}-modal__form`);

      // checkbox
      const checkboxes = $$('input[type="checkbox"]', module);
      checkboxes.forEach(item => {
        item.removeAttribute('tabindex');
        item.insertAdjacentHTML('afterend', `<i class="checkbox">${svg.check}</i>`);        
      });


      // Submit button
      const submitBtn = $('input[type="submit"]', module);
      const newSubmitBtn = document.createElement('button');

      if (!submitBtn) return;

      for (var i = 0, l = submitBtn.attributes.length; i < l; ++i) {
        var nodeName = submitBtn.attributes.item(i).nodeName;
        var nodeValue = submitBtn.attributes.item(i).nodeValue;

        newSubmitBtn.setAttribute(nodeName, nodeValue);
      }

      newSubmitBtn.removeAttribute('tabindex');
      newSubmitBtn.classList.add('dlr-button', 'form-submit');
      newSubmitBtn.insertAdjacentHTML('afterbegin', `Subscribe ${svg.submit}`);
      submitBtn.parentNode.replaceChild(newSubmitBtn, submitBtn);
      newSubmitBtn.insertAdjacentHTML('afterend', `<div><a href="javascript:formvoid(0);" role="button" class="dlr-button form-cancel" aria-label="Cancel">Cancel</a></div>`)

      const cancelBtn = $('a.form-cancel', module);
      cancelBtn.addEventListener('click', e => MessageBus.publish('MODAL_HANDLER', { module: module, isExpanded: false }));



      if (!htmlForm) {
        htmlForm = gformContainer.innerHTML;
      }
    });

    MessageBus.subscribe('GFORM_OBSERVER', ({ module }) => {
      const config = {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      };

      const callback = (mutations) => {
        // Use traditional 'for loops' for IE 11    
        for (const mutation of mutations) {
          if (!mutation.addedNodes.length) return;

          mutation.addedNodes.forEach(node => {
            console.log(node);

            if (node.tagName == 'FORM') {
              MessageBus.publish('GFORM_INIT', { module: module });
            }


            if (node.classList && node.classList.contains('gform_confirmation_wrapper')) {
              MessageBus.publish('GFORM_CONFIRMATION', { module: module, container: node });
            }
          });
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(module, config);

    });


    MessageBus.subscribe('GFORM_CONFIRMATION', ({ module }) => {
      const confirmation = $('.gform_confirmation_wrapper', module);
      const emailField = $(`${SELECTOR}__email-field input`, module);

      if (!confirmation) return;

      module.classList.add(FORM_SUCEESS);
      setElementFocus(confirmation);

      emailField.value = '';
    });



    MessageBus.subscribe('MODAL_HANDLER', ({ module, isExpanded, emailValue }) => {
      const modal = $(`${SELECTOR}-modal`, module);
      const emailField = $(`${SELECTOR}__email-field input`, module);
      const gFormEmailFieldFirst = $('form input[type="email"]', modal);
      const gFormEmailField = gFormEmailFieldFirst ? gFormEmailFieldFirst : $('.ginput_container_email input[type="text"]', modal);
      const confirmation = $('.gform_confirmation_wrapper', module);

      if (isExpanded && emailValue) {
        modal.classList.add(IS_EXPANDED);
        gFormEmailField.value = emailValue;
        setElementFocus(modal);
      }
      else {
        modal.classList.remove(IS_EXPANDED);
        emailField.focus();

        if (confirmation) {
          MessageBus.publish('REBUILD_GFORM', { module: module });
        }
      }
    });

    MessageBus.subscribe('REBUILD_GFORM', ({ module }) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlForm, 'text/html');
      const form = $('div.gform_wrapper', doc);

      const gformContainer = $(`${SELECTOR}-modal__form`, module);
      const divs = $$(`${SELECTOR}-modal__form > div`, module);

      divs.forEach(div => div.remove());
      gformContainer.prepend(form);
      module.classList.remove(FORM_SUCEESS);
    });
  },

  /**
   * 3. RENDERING
   *
   * Use `finalize` for actions that should run
   * as soon as the module is rendered to the page
   * - e.g. Event Listeners, DOM Manipulations,
   *        MessageBus Publishers, etc
   */
  finalize(GlobalEvents, MessageBus) {
    const { onScroll, onResize, debounced } = GlobalEvents;
    console.log('newsletter finalize');

    MessageBus.publish('GFORM_INIT', { module: ELEMENT });
    MessageBus.publish('GFORM_OBSERVER', { module: ELEMENT });

    emailSubmitBtn.addEventListener('click', e => MessageBus.publish('EMAIL_SUBMIT', { module: ELEMENT, event: e }));
    closeBtn.addEventListener('click', e => MessageBus.publish('MODAL_HANDLER', { module: ELEMENT, isExpanded: false }));
  },
};



// WEBPACK FOOTER //
// ../views/modules/newsletter/newsletter.js